import { Tab, TabList, Divider, Button } from "@fluentui/react-components";
import { useEffect, useState } from "react";
import "../style.css";
import { useDispatch, useSelector } from "react-redux";
import store, { AppDispatch, RootState } from "../../../../redux/store";
import ReceivedDocuments from "./ReceivedDocuments";
import SentDocuments from "./SentDocuments";
import { ArrowClockwise24Filled, Send24Filled } from "@fluentui/react-icons";
import { useParams } from "react-router-dom";
import SendFile from "./sendFile";
import { fetchCustomerMessages } from "../../../../redux/clientPortal/clientPortalslice";

enum TabValues {
  tab1 = "received",
  tab2 = "sent",
}

function Documents({ customerId, notify, customerDocuments }: any) {
  const dispatch = useDispatch<AppDispatch>();
  const [sendFile, setSendFile] = useState<boolean>(false);
  const receivedDocuments = customerDocuments.received;
  const sentDocuments = customerDocuments.sent;

  const unreadDocumentsCount =
    receivedDocuments?.filter((msg: any) => !msg.Read).length || 0;

  const [selectedTab, setSelectedTab] = useState<TabValues>(TabValues.tab1);

  const handleComposeClick = () => {
    setSendFile(true);
  };
  return (
    <>
      <div className="cp_card">
        <div className="portal_card_header">
          <div className="justify_between">
            <div className="portal_heading">
              <h5 className="grey_bold_text">Documents</h5>
              <p className="unread_count">{unreadDocumentsCount.toString()}</p>
              <ArrowClockwise24Filled
                onClick={() => dispatch(fetchCustomerMessages({ customerId }))}
              />
            </div>
            <div style={{ padding: "0 10px" }}>
              <Button
                appearance="primary"
                className="asc-button-primary"
                icon={<Send24Filled />}
                onClick={handleComposeClick}
              >
                Send File
              </Button>
            </div>
          </div>
          <TabList
            defaultSelectedValue={TabValues.tab1}
            onTabSelect={(event, data) =>
              setSelectedTab(data.value as TabValues)
            }
          >
            <Tab value={TabValues.tab1}>Received</Tab>
            <Tab value={TabValues.tab2}>Sent</Tab>
          </TabList>
        </div>
        <Divider />
        <div className="data_body">
          {selectedTab === TabValues.tab1 && (
            <ReceivedDocuments
              customerId={customerId}
              notify={notify}
              receivedDocuments={receivedDocuments}
            />
          )}
          {selectedTab === TabValues.tab2 && (
            <SentDocuments
              customerId={customerId}
              notify={notify}
              sentDocuments={sentDocuments}
            />
          )}
        </div>
      </div>
      <SendFile
        open={sendFile}
        customerId={customerId}
        notify={notify}
        onClose={() => setSendFile(false)}
      />
    </>
  );
}

export default Documents;
